require('./bootstrap');
require('es6-promise').polyfill();
AOS = require('../vendor/aos.js');

var site = function(){
    var top, left;
    // Release the scroll locking
    var unlockWindowScroll = function() {
        $('body').css('overflow', 'auto');
        $(window).off('scroll');
        $(window).scrollTop(top).scrollLeft(left);
		handlePopupCta();
    };

    // Force scrolling to be locked in its current position
    var lockWindowScroll = function() {
        top = $(window).scrollTop();
        left = $(window).scrollLeft();
        $('body').css('overflow', 'hidden');
        $(window).on('scroll', function() {
            $(this).scrollTop(top).scrollLeft(left);
        });
    };

    var handleScrollTo = function() {
        $('a[href^="#"].scroll-to').on('click', function(e){
            e.preventDefault();

            $('html, body').animate({
                'scrollTop': $($(this).attr('href')).offset().top - $('header').outerHeight()
            }, 1500, 'swing')
        });
    };

    var handleMobileNavButton = function() {
        $('header .mobile-button').on('click', function(e){
            e.preventDefault();
            var $header = $(this).parents('header');
            $header.toggleClass('menu-open');

            if ($header.hasClass('menu-open')) {
                lockWindowScroll();
            } else {
                unlockWindowScroll();
            }
        });
    };

	var setCookie = function(name,value,days) {
		var expires = "";
		if (days) {
			var date = new Date();
			date.setTime(date.getTime() + (days*24*60*60*1000));
			expires = "; expires=" + date.toUTCString();
		}
		document.cookie = name + "=" + (value || "")  + expires + "; path=/";
	};

	var getCookie = function(name) {
		var nameEQ = name + "=";
		var ca = document.cookie.split(';');
		for(var i=0;i < ca.length;i++) {
			var c = ca[i];
			while (c.charAt(0)===' ') c = c.substring(1,c.length);
			if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length,c.length);
		}
		return null;
	};

	var eraseCookie = function(name) {
		document.cookie = name+'=; Max-Age=-99999999;';
	};

    var handleCarousels = function() {
        var $carousels = jQuery(".carousel"),
            standardCarousels = [];

        $carousels.each(function (i, e) {
            var $carousel = jQuery(e),
                $section = $carousel.parents('section'),
                options = {
                    'items': 1,
                    'smartSpeed': 600,
                    'autoplaySpeed': 600,
                    'autoplay': true,
                    'autoplayTimeout': 4000,
                    'autoplayHoverPause': true,
                    'loop': true,
                    'URLhashListener': true,
                    'startPosition': 'URLHash'
                };

            standardCarousels[i] = $carousel;

            if ($carousel.is('[data-carousel-with-fade]')) {
                options['animateOut'] = 'fadeOut';
                options['animateIn'] = 'fadeIn';
            }

            if ($carousel.is('[data-carousel-is-vertical]') && !isTablet()) {
                options['animateOut'] = 'fadeOutUp';
                options['animateIn'] = 'fadeInUp';
            }

	        if ($carousel.is('[data-carousel-without-dots]')) {
		        options['dots'] = false;
	        }

	        if ($carousel.is('[data-carousel-without-drag]')) {
		        options['mouseDrag'] = false;
		        options['touchDrag'] = false;
		        options['touchDrag'] = false;
	        }

	        if ($carousel.is('[data-carousel-no-autoplay]')) {
		        options['autoplay'] = false;
	        }

            if ($carousel.is('[data-carousel-timeout]')) {
                options['autoplayTimeout'] = $carousel.attr('data-carousel-timeout');
            }

            if ($carousel.is('[data-carousel-no-autoplay-hover-pause]')) {
                options['autoplayHoverPause'] = false;
            }

            if (isMobile() && $carousel.is('[data-mobile-carousel-items]')) {
                options['items'] = $carousel.attr('data-mobile-carousel-items');
            } else if ($carousel.is('[data-carousel-items]')) {
                options['items'] = $carousel.attr('data-carousel-items');
            }

            $carousel.owlCarousel(options);

	        $carousel.on('changed.owl.carousel', function (event) {
		        var index = event.property.value - 2;
		        if (index >= event.item.count) {
			        index = 0;
		        } else if (index < 0) {
			        index = event.item.count - 1;
		        }
		        var loopIndex = index + 1;

		        standardCarousels[i].index = index;

		        $section.find('.overflowing-bg').removeClass('active');
		        $section.find('.overflowing-bg[data-loop-index=' + loopIndex + ']').addClass('active');

		        if ($carousel.is('[data-carousel-with-count]')) {
			        $section.find('.slide-nav .slide-count').empty().append((loopIndex.toString().length === 1 ? '0' : '') + loopIndex);
		        }

		        if ($carousel.is('[data-carousel-is-vertical]') && isTablet()) {
			        $carousel.height($carousel.find('.owl-item').eq(event.item.index).height());
		        }
	        });

	        if ($carousel.is('[data-carousel-is-vertical]') && isTablet()) {
		        $carousel.height($carousel.find('.owl-item.active').height());
	        }

            if ($carousel.is('[data-carousel-with-arrows]')) {
                $section.find(".next").on('click', function (e) {
                    e.preventDefault();

	                if ($carousel.is('[data-carousel-is-vertical]') && !isTablet()) {
		                $carousel.data('owl.carousel').options.animateOut = 'fadeOutUp';
		                $carousel.data('owl.carousel').options.animateIn = 'fadeInUp';
		                $carousel.trigger('refresh.owl.carousel');
	                }

	                if ($carousel.is('[data-carousel-with-custom-dots]')) {
		                var index = ($section.find('.dot.active').index('.dot') + 1),
			                dotCount = $section.find('.dot').length;

		                if (index === dotCount) {
			                index = 1;
		                } else {
			                index += 1;
		                }

		                $section.find('.dot').removeClass('active');
		                $section.find('.dot[data-loop-index*="|' + index + '|"]').addClass('active');
	                }

                    $carousel.trigger('next.owl.carousel');
                });

                $section.find(".prev").on('click', function (e) {
                    e.preventDefault();

	                if ($carousel.is('[data-carousel-is-vertical]') && !isTablet()) {
		                $carousel.data('owl.carousel').options.animateOut = 'fadeOutDown';
		                $carousel.data('owl.carousel').options.animateIn = 'fadeInDown';
		                $carousel.trigger('refresh.owl.carousel');
	                }

	                if ($carousel.is('[data-carousel-with-custom-dots]')) {
	                	var index = ($section.find('.dot.active').index('.dot') + 1),
		                    dotCount = $section.find('.dot').length;

		                if (index === 1) {
			                index = dotCount;
		                } else {
			                index -= 1;
		                }

		                $section.find('.dot').removeClass('active');
		                $section.find('.dot[data-loop-index*="|' + index + '|"]').addClass('active');
	                }

                    $carousel.trigger('prev.owl.carousel');
                });
            } else {
                $section.find(".prev, .next").hide();
            }

            $section.find('a[data-carousel-goto]').on('click', function(e){
                e.preventDefault();

                var $a = jQuery(this),
                    newIndex = parseInt($a.attr('data-carousel-goto')) - 1,
                    hashSplit = $a.attr('href').split('#');

                if (hashSplit[1]) {
                    window.location.hash = hashSplit[1];
                }

                if (typeof newIndex == 'number' && !isNaN(newIndex)) {
                    $carousel.trigger('to.owl.carousel', newIndex);
                }

	            if ($carousel.is('[data-carousel-with-custom-dots]')) {
		            $section.find('.dot').removeClass('active');
		            $section.find('.dot[data-loop-index*="|' + (newIndex + 1) + '|"]').addClass('active');
	            }
            });

            if (jQuery('a[href*="' + window.location.hash + '"]').length) {
                jQuery('a[href*="' + window.location.hash + '"]').addClass('active').siblings('a').removeClass('active');
            }
        });
    };

	var isTablet = function() {
		return (jQuery(window).width() <= 768);
	};

	var isMobile = function() {
		return (jQuery(window).width() <= 480);
	};

	var handlePopupCta = function() {
		$('.popup-cta-container .button').off('click').on('click', function(e){
			e.preventDefault();

			var $button = $(this);

			$button.parents('.popup-cta-container').toggleClass('active');
		});

		$(window).on('scroll', function(){
			var scrollTop = window.pageYOffset,
				$footer = $('footer');

			if ((scrollTop + $(window).height()) > $(document).height() - $footer.outerHeight()) {
				$('.popup-cta-container').css({
					'position': 'absolute',
					'bottom': $footer.outerHeight() + 'px'
				}).addClass('fixed');
			} else {
				$('.popup-cta-container').css({
					'position': 'fixed',
					'bottom': '0'
				}).removeClass('fixed');
			}
		});
	};

	var handlePopup = function() {
		$('[data-open-popup]').on('click', function(e){
			e.preventDefault();

			var $button = $(this);
			var popupId = $button.attr('data-open-popup');
			var $popup = $('#' + popupId);

			$popup.addClass('active');

			if ($button.is('[data-open-popup-team-member]')) {
				var memberId = $button.attr('data-open-popup-team-member'),
					memberHeight = $popup.find('[data-team-member="' + memberId + '"]').height();

				$popup.find('[data-team-member="' + memberId + '"]').addClass('active').siblings().removeClass('active');

				$popup.find('.popup-inner').height(memberHeight);
			}

			lockWindowScroll();
		});

		$('[data-close-popup]').on('click', function(e){
			e.preventDefault();

			var $popupContainer = $(this).parents('.popup-container');

			$popupContainer.removeClass('active').find('[data-team-member]').removeClass('active');

			if (getCookie('stayClosed') !== 'true' && $popupContainer.is('[data-signup-popup]')) {
				// Set cookie to stop the popup opening for 7 days
				setCookie('stayClosed', 'true', 7);
			}
			if ($popupContainer.is('[data-signup-popup]') && timerPopupHasShown && getCookie('stayClosedTimer') !== 'true') {
				// Set cookie to stop the popup opening for 7 days
				setCookie('stayClosedTimer', 'true', 7);
			}

			unlockWindowScroll();
		});
	};

	var objectFitVideos = function (videos) {
		'use strict';

		var isEdge = navigator.userAgent.indexOf('Edge/') >= 0;

		var testImg                = new Image(),
			supportsObjectFit      = 'object-fit' in testImg.style && !isEdge,
			supportsObjectPosition = 'object-position' in testImg.style && !isEdge,
			propRegex              = /(object-fit|object-position)\s*:\s*([-\w\s%]+)/g;

		if (!supportsObjectFit || !supportsObjectPosition) {
			initialize(videos);
			throttle('resize', 'optimizedResize');
		}

		/**
		 * Parse the style and look for the special font-family tag
		 * @param  {object} $el The element to parse
		 * @return {object}     The font-family properties we're interested in
		 */
		function getStyle ($el) {
			var style  = getComputedStyle($el).fontFamily,
				parsed = null,
				props  = {};

			while ((parsed = propRegex.exec(style)) !== null) {
				props[parsed[1]] = parsed[2];
			}

			if (props['object-position'])
				return parsePosition(props);

			return props;
		}

		/**
		 * Initialize all the relevant video elements and get them fitted
		 */
		function initialize (videos) {
			var index = -1;

			if (!videos) {
				// if no videos given, query all video elements
				videos = document.querySelectorAll('video');
			} else if (!('length' in videos)) {
				// convert to an array for proper looping if an array or NodeList
				// was not given
				videos = [videos];
			}

			while (videos[++index]) {
				var style = getStyle(videos[index]);

				// only do work if the property is on the element
				if (style['object-fit'] || style['object-position']) {
					// set the default values
					style['object-fit'] = style['object-fit'] || 'fill';
					fitIt(videos[index], style);
				}
			}
		}

		/**
		 * Object Fit
		 * @param  {object} $el Element to fit
		 * @return {object}     The element's relevant properties
		 */
		function fitIt ($el, style) {
			// fill is the default behavior, no action is necessary
			if (style['object-fit'] === 'fill')
				return;

			// convenience style properties on the source element
			var setCss = $el.style,
				getCss = window.getComputedStyle($el);

			// create and insert a wrapper element
			var $wrap = document.createElement('object-fit');
			$wrap.appendChild($el.parentNode.replaceChild($wrap, $el));

			// style the wrapper element to mostly match the source element
			var wrapCss = {
				height:    '100%',
				width:     '100%',
				boxSizing: 'content-box',
				display:   'inline-block',
				overflow:  'hidden'
			};

			'backgroundColor backgroundImage borderColor borderStyle borderWidth bottom fontSize lineHeight left opacity margin position right top visibility'.replace(/\w+/g, function (key) {
				wrapCss[key] = getCss[key];
			});

			for (var key in wrapCss)
				$wrap.style[key] = wrapCss[key];

			// give the source element some saner styles
			setCss.border  = setCss.margin = setCss.padding = 0;
			setCss.display = 'block';
			setCss.opacity = 1;

			// set up the event handlers
			$el.addEventListener('loadedmetadata', doWork);
			window.addEventListener('optimizedResize', doWork);

			// we may have missed the loadedmetadata event, so if the video has loaded
			// enough data, just drop the event listener and execute
			if ($el.readyState >= 1) {
				$el.removeEventListener('loadedmetadata', doWork);
				doWork();
			}

			/**
			 * Do the actual sizing. Math.
			 * @methodOf fitIt
			 */
			function doWork () {
				// the actual size and ratio of the video
				// we do this here, even though it doesn't change, because
				// at this point we can be sure the metadata has loaded
				var videoWidth  = $el.videoWidth,
					videoHeight = $el.videoHeight,
					videoRatio  = videoWidth / videoHeight;

				var wrapWidth  = $wrap.clientWidth,
					wrapHeight = $wrap.clientHeight,
					wrapRatio  = wrapWidth / wrapHeight;

				var newHeight = 0,
					newWidth  = 0;
				setCss.marginLeft = setCss.marginTop = 0;

				// basically we do the opposite action for contain and cover,
				// depending on whether the video aspect ratio is less than or
				// greater than the wrapper's aspect ratio
				if (videoRatio < wrapRatio ?
						style['object-fit'] === 'contain' : style['object-fit'] === 'cover') {
					newHeight = wrapHeight * videoRatio;
					newWidth  = wrapWidth / videoRatio;

					setCss.width  = Math.round(newHeight) + 'px';
					setCss.height = wrapHeight + 'px';

					if (style['object-position-x'] === 'left')
						setCss.marginLeft = 0;
					else if (style['object-position-x'] === 'right')
						setCss.marginLeft = Math.round(wrapWidth - newHeight) + 'px';
					else
						setCss.marginLeft = Math.round((wrapWidth - newHeight) / 2) + 'px';
				} else {
					newWidth = wrapWidth / videoRatio;

					setCss.width     = wrapWidth + 'px';
					setCss.height    = Math.round(newWidth) + 'px';

					if (style['object-position-y'] === 'top')
						setCss.marginTop = 0;
					else if (style['object-position-y'] === 'bottom')
						setCss.marginTop = Math.round(wrapHeight - newWidth) + 'px';
					else
						setCss.marginTop = Math.round((wrapHeight - newWidth) / 2) + 'px';
				}

				// play the video if autoplay is set
				if ($el.autoplay)
					$el.play();
			}
		}

		/**
		 * Split the object-position property into x and y position properties
		 * @param  {object} style Relevant element styles
		 * @return {object}       The style object with the added x and y props
		 */
		function parsePosition (style) {
			if (~style['object-position'].indexOf('left'))
				style['object-position-x'] = 'left';
			else if (~style['object-position'].indexOf('right'))
				style['object-position-x'] = 'right';
			else
				style['object-position-x'] = 'center';

			if (~style['object-position'].indexOf('top'))
				style['object-position-y'] = 'top';
			else if (~style['object-position'].indexOf('bottom'))
				style['object-position-y'] = 'bottom';
			else
				style['object-position-y'] = 'center';

			return style;
		}

		/**
		 * Throttle an event with RequestAnimationFrame API for better performance
		 * @param  {string} type The event to throttle
		 * @param  {string} name Custom event name to listen for
		 * @param  {object} obj  Optional object to attach the event to
		 */
		function throttle (type, name, obj) {
			obj = obj || window;
			var running = false,
				evt     = null;

			// IE does not support the CustomEvent constructor
			// so if that fails do it the old way
			try {
				evt = new CustomEvent(name);
			} catch (e) {
				evt = document.createEvent('Event');
				evt.initEvent(name, true, true);
			}

			var func = function () {
				if (running) return;

				running = true;
				requestAnimationFrame(function () {
					obj.dispatchEvent(evt);
					running = false;
				});
			};

			obj.addEventListener(type, func);
		}
	};

	var forms = [];

	var handleForms = function() {
		jQuery('[data-contact-form]').each(function(i, e){
			forms[i] = {
				'submitting': false
			};

			$(e).on('submit', function(e){
				e.preventDefault();

				var $form = $(this),
					data = $form.serializeObject();

				if (forms[i].submittingForm) {
					return;
				}

				$form.find('.button').attr('disabled', true).addClass('button-disabled').empty().append('Sending...');
				forms[i].submittingForm = true;

				if (typeof data['g-recaptcha-response'] === 'undefined' && $form.find('[name="g-recaptcha-response"]').length) {
					data['g-recaptcha-response'] = $form.find('[name="g-recaptcha-response"]').val();
				}

				$.ajax({
					'url': $form.attr('action'),
					'method': 'POST',
					'data': data,
					'dataType': 'JSON',
					'success': function (response) {
						if (!response.success) {
							forms[i].submittingForm = false;
							$form.find('.button').attr('disabled', false).removeClass('button-disabled').empty().append('<span class="text">Submit</span> <span class="arrow">>></span>');

							var errorHtml = '';

							for (var x in response.errors.message) {
								if (response.errors.message.hasOwnProperty(x)) {
									errorHtml += '<p class="error">' + response.errors.message[x] + '</p>';
								}
							}

							$form.find('p.error').remove();
							$form.find('.button').before(errorHtml);
						} else {
							$form.find('p.error').empty();
							$form.find('.input-row').addClass('disabled');
							$form.find('.button').slideUp();
							$form.find('.contact-success').fadeIn();

							if ($form.attr('id') === 'signupPopupForm' || $form.attr('id') === 'signupFooterForm') {
								// Set cookie to stop the popup opening
								setCookie('stayClosed', 'true', 99999);
								setCookie('stayClosedTimer', 'true', 99999);
							}
						}
					}
				});
			});
		});
	};

	var timerPopupHasShown = false;

	var handleSignupPopup = function() {
		var $body = $('body');

		setTimeout(function () {
			if (getCookie('stayClosedTimer') !== 'true') {
				$('#signupPopup').addClass('active');
				lockWindowScroll();
				timerPopupHasShown = true;
			}
		}, 60000);

		if (getCookie('stayClosed') === 'true') {
			return;
		}

		$body.on('mouseout', function(e){
			e.stopPropagation();

			if (getCookie('stayClosed') === 'true') {
				$body.off('mouseout');
			}

			if (typeof e.relatedTarget === 'undefined' || !e.relatedTarget || (typeof e.relatedTarget.tagName !== 'undefined' && e.relatedTarget.tagName === 'HTML')) {
				$('#signupPopup').addClass('active');
				lockWindowScroll();
			}
		});

		$body.on('mouseenter', function(e){
			e.stopPropagation();

			if (getCookie('stayClosed') === 'true') {
				$body.off('mouseenter');
			}
		});
	};

	return {
        init: function() {
            var el = document.querySelector('.ss');
            SimpleScrollbar.initEl(el);

            AOS.init({
                'duration': 400,
                'easing': 'ease-in-sine',
                'delay': 100,
                'once': true
            });

            //handleSignupPopup();
            handleForms();
	        handlePopupCta();
	        handlePopup();
            handleScrollTo();
            handleMobileNavButton();
            handleCarousels();
	        objectFitVideos(document.querySelectorAll('.video-cover'));

	        for (var i in document.querySelectorAll('.video-cover')) {
	        	if (document.querySelectorAll('.video-cover').hasOwnProperty(i)) {
			        document.querySelectorAll('.video-cover')[i].play();
		        }
	        }
        }
    }
}();

$(document).ready(site.init);
